<loading-component *ngIf="_resourceService.loading || _userService.loading"></loading-component>

<div class="alert alert-danger" role="alert" *ngIf="_userService.danger || alertDanger">
  {{ _userService.danger | translate }} {{ alertDanger | translate }}
</div>

<div class="alert alert-warning" role="alert" *ngIf="_userService.warning || alertWarning">
  {{ _userService.warning | translate }} {{ alertWarning | translate }}
</div>

<div class="alert alert-success" role="alert" *ngIf="_userService.success || alertSuccess">
  {{ _userService.success | translate }} {{ alertSuccess | translate }}
</div>

<h4>{{ 'REGISTER' | translate}}</h4>
<hr>
<form [formGroup]="forma" (ngSubmit)="validateForm()">
  <fieldset [disabled]="registerOnlyWithPin">

    <div class="row">

      <div [ngClass]="optionalFields.SECOND_SURNAME ? 'col-md-4' : 'col-md-6'">
        <div class="form-group">
          <label>
            {{ 'NAME' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.name" name="name" type="text"
              placeholder="{{ 'NAME' | translate}}" formControlName="name">
          </div>
        </div>
      </div>

      <div [ngClass]="optionalFields.SECOND_SURNAME ? 'col-md-4' : 'col-md-6'">
        <div class="form-group">
          <label>
            {{ 'LASTNAME' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.lastname" name="lastname" type="text"
              placeholder="{{ 'LASTNAME' | translate}}" formControlName="lastname">
          </div>
        </div>
      </div>

      <div class="col-md-4" *ngIf="optionalFields.SECOND_SURNAME">
        <div class="form-group">
          <label>
            {{ 'SECOND_SURNAME' | translate}}
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.birthname" name="birthname" type="text"
              placeholder="{{ 'SECOND_SURNAME' | translate}}" formControlName="birthname">
          </div>
        </div>
      </div>

    </div>

    <div class="row">


      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'ACCESS_EMAIL' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.email" name="email" type="email"
              placeholder="{{ 'EMAIL' | translate}}" formControlName="email">
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="!registerOnlyWithPin">
        <div class="form-group">
          <label>
            {{ 'RETYPE_ACCESS_EMAIL' | translate}}
          </label>
          <div class="col-12">
            <input class="form-control" name="confirmMail" type="email"
              placeholder="{{ 'RETYPE_EMAIL' | translate}}" formControlName="confirmMail">
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'BIRTHDATE' | translate}} *
          </label>
          <div class="input-group col-12">
            <p-calendar #calendar class="form-control" [(ngModel)]="user.birthDate"
              formControlName="birthDate" name="birthDate" dateFormat="dd-mm-yy"
              [locale]="locale.localeObject" [monthNavigator]="true" [yearNavigator]="true"
              yearRange="1900:2020"
              [inputStyle]="{'border':'none', 'font-size': '1em', 'padding': 'initial'}"
              [maxDate]="maxDate">
            </p-calendar>
            <!-- <input class="form-control" placeholder="dd-mm-yyyy" name="dp"
              [(ngModel)]="user.birthDate" ngbDatepicker #d="ngbDatepicker" [minDate]="minDate"
              formControlName="birthDate" name="birthDate"> -->
            <div class="input-group-append">
              <button class="btn btn-outline-secondary fas fa-calendar-alt"
                (click)="calendar.showOverlay()" type="button"></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'PHONE_NUMBER' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.phoneNumber" name="phoneNumber" type="text"
              placeholder="{{ 'PHONE_NUMBER' | translate}}" formControlName="phoneNumber">
          </div>
        </div>
      </div>


      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'ADDRESS' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.address" name="address" type="text"
              placeholder="{{ 'ADDRESS' | translate}}" formControlName="address" maxlength="35">
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'CITY' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.city" name="city" type="text"
              placeholder="{{ 'CITY' | translate}}" formControlName="city" maxlength="25">
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'POSTAL_CODE' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.postalCode" name="postalCode" type="text"
              placeholder="{{ 'POSTAL_CODE' | translate}}" formControlName="postalCode">
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'COUNTRY' | translate}} *
          </label>
          <div class="col-12">
            <select class="form-control" [ngModel]="user.country" name="country"
              placeholder="Select country" formControlName="country">
              <option value="">
                {{ 'SELECT_YOUR_COUNTRY' | translate}}
              </option>
              <option *ngFor="let country of _resourceService.countries" [value]="country.id">{{
                country.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Optionals fields -->

      <div class="col-md-6" *ngIf="optionalFields.STATE">
        <div class="form-group">
          <label>
            {{ 'STATE' | translate}} *
          </label>
          <div class="col-12">
            <select class="form-control" [ngModel]="user.state" name="state"
              placeholder="Select state" formControlName="state">
              <option value="">
                {{ 'SELECT_YOUR_STATE' | translate}}
              </option>
              <option *ngFor="let state of _resourceService.states" [value]="state.id">{{
                state.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="optionalFields.SOCIAL_SECURITY_NUMBER">
        <div class="form-group">
          <label>
            {{ 'SOCIAL_SECURITY_NUMBER' | translate}}
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.socialSecurityNumber"
              name="socialSecurityNumber" type="text"
              placeholder="{{ 'SOCIAL_SECURITY_NUMBER' | translate}}"
              formControlName="socialSecurityNumber" disabled>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="optionalFields.DOCNUMBER">
        <div class="form-group">
          <label>
            {{ 'DOC_TYPE' | translate}} *
          </label>
          <div class="col-12">
            <select class="form-control" [ngModel]="user.docType" name="docType"
              placeholder="Select docType" formControlName="docType">
              <option value="">
                {{ 'SELECT_YOUR_DOC_TYPE' | translate}}
              </option>
              <option *ngFor="let docType of _resourceService.doctypes" [value]="docType.id">{{
                docType.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="optionalFields.DOCNUMBER">
        <div class="form-group">
          <label>
            {{ 'DOCNUMBER' | translate}} *
          </label>
          <div class="col-12">
            <input class="form-control" [ngModel]="user.docNumber" name="docNumber" type="text"
              placeholder="{{ 'DOCNUMBER' | translate}}" formControlName="docNumber" maxlength="15">
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="optionalFields.GENDER">
        <div class="form-group">
          <label>
            {{ 'GENDER' | translate }} *
          </label>
          <div class="col-12">
            <select class="form-control" [ngModel]="user.gender" name="gender"
              placeholder="Select gender" formControlName="gender">
              <option value="">
                {{ 'SELECT_YOUR_SEX' | translate}}
              </option>
              <option *ngFor="let gender of _resourceService.sexs" [value]="gender.id">{{
                gender.name
                }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="optionalFields.LANGUAGE">
        <div class="form-group">
          <label>
            {{ 'LANGUAGE' | translate}}
          </label>
          <div class="col-12">
            <select class="form-control" [ngModel]="user.language" name="language"
              placeholder="Select language" formControlName="language">
              <option value="">
                {{ 'SELECT_YOUR_LANGUAGE' | translate}}
              </option>
              <option *ngFor="let language of _resourceService.languages" [value]="language.id">{{
                language.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>


    <!-- Fin del row con los optionals fields -->


    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'PASSWORD' | translate}}
          </label>
          <div class="col-12">
            <input class="form-control" type="password" placeholder="Password"
              formControlName="password">
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            {{ 'RETYPE_PASSWORD' | translate}}
          </label>
          <div class="col-12">
            <input class="form-control" type="password" placeholder="Confirm password"
              formControlName="confirmpassword">
          </div>
        </div>
      </div>

    </div>

    <!-- Campos ocultos para enviar el pin y y el patnr -->
    <input type="hidden" name="patnr" value="{{user.patnr}}">
    <input type="hidden" name="pin" value="{{pin}}">

    <div class="row justify-content-center" *ngIf="hasCaptcha">
      <div class="form-group">
        <label>
          {{ 'CAPTCHA' | translate}}
        </label>
        <re-captcha (resolved)="resolved($event)"
          siteKey="6LdFnDoUAAAAALlrTJM-8-hT1jJJ5WYIzaQ1fnJO">
        </re-captcha>
      </div>
    </div>

    <div class="form-group row margin-top" *ngIf="!registerOnlyWithPin">
      <div class="form-group col-md-6">
        <button type="submit" class="btn btn-main-color btn-block"
          [disabled]="!captchaResolved && hasCaptcha">
          {{ 'REGISTER' | translate}}
        </button>
        <div class="text-right main-color"><small data-toggle="modal" data-target="#PinModal"
            class="pointer">{{
            'I_HAVE_PIN' |
            translate}}</small></div>
      </div>
      <div class="col-md-6">
        <button type="reset" class="btn btn-secondary-color btn-block">
          {{ 'RESET' | translate}}
        </button>
      </div>
    </div>

    <div class="form-group row margin-top" *ngIf="registerOnlyWithPin">
      <div class="form-group col-md-6 mx-auto">
        <button type="submit" class="btn btn-main-color btn-block"
          [disabled]="!pin || _userService.danger || alertDanger || !captchaResolved">
          {{ 'REGISTER' | translate}}
        </button>
        <div class="btn btn-secondary-color btn-sm pull-right margin-top">
          <small data-toggle="modal" data-target="#PinModal" class="pointer">
            {{ 'REOPEN_PIN_MODAL' | translate}}
          </small>
        </div>
      </div>
    </div>
  </fieldset>
</form>

<!-- The Pin Modal -->
<div class="modal fade" id="PinModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'IDENTIFIER_PIN' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal"
          (click)="alertDanger = null">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" *ngIf="_resourceService.loading || _userService.loading">
        <loading-component>
        </loading-component>
      </div>

      <div *ngIf="!_resourceService.loading && !_userService.loading">
        <div class="modal-body">

          <div class="alert alert-danger" role="alert" *ngIf="_userService.danger || alertDanger">
            {{ _userService.danger | translate }} {{ alertDanger | translate }}
          </div>

          <div *ngIf="!registerOnlyWithPin">
            {{ 'BODY_PIN' | translate}}
          </div>
          <div *ngIf="registerOnlyWithPin">
            {{ 'BODY_MANDATORY_PIN' | translate}}
          </div>
        </div>

        <div class="form-group col-md-12">
          <label>{{ 'IDENTIFIER_PIN' | translate}}:&nbsp;</label>
          <input class="form-control" [(ngModel)]="pin" name="pin" type="text" placeholder="PIN">
        </div>



        <!-- Modal footer -->
        <div class="modal-footer margin-top">
          <button type="button" class="btn btn-main-color" (click)="sendPin()">OK</button>
          <button type="button" class="btn btn-secondary-color" data-dismiss="modal"
            *ngIf="!registerOnlyWithPin" (click)="alertDanger = null">{{
            'DONT_HAVE_PIN' | translate}}</button>
        </div>
      </div>

    </div>
  </div>
</div>